"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCustomUIEvent = void 0;
const createCustomUIEvent = (name, payload) => new CustomEvent(name, payload);
exports.createCustomUIEvent = createCustomUIEvent;
//# sourceMappingURL=createCustomUIEvent.js.map